const MIN_LINE = 12; // shorter fragments ("the", "1.28") would match everywhere

const squash = (s: string) => s.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

/** Whether one line of the PDF's text belongs to the passage being pointed at. PDFs split text into lines, so a
 * line of the page is matched against the passage rather than the other way round. */
export function inPassage(line: string, passage: string | null): boolean {
  if (!passage) return false;
  const l = squash(line);
  return l.length >= MIN_LINE && squash(passage).includes(l);
}

const ESCAPES: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

/** The PDF text layer takes HTML, so the report's own text is escaped before it is marked up. */
export const escapeHtml = (s: string) => s.replace(/[&<>"']/g, (c) => ESCAPES[c] ?? c);

// A whole printed number: not the 26 of Dec-26 or 2Q26, and not the 1.28 inside 1.286.
const NUMBER = /(?<![\w.,-])-?\d[\d,]*(?:\.\d+)?(?![\w-]|\.\d)/g;

/** A line of the PDF's text as HTML, with every number equal to the figure marked. 1.280 and 1.28 are the same figure. */
export function markFigure(line: string, figure: number | null): string {
  if (figure === null) return escapeHtml(line);
  let html = '';
  let at = 0;
  for (const m of line.matchAll(NUMBER)) {
    if (Number(m[0].replaceAll(',', '')) !== figure) continue;
    html += `${escapeHtml(line.slice(at, m.index))}<mark>${escapeHtml(m[0])}</mark>`;
    at = m.index + m[0].length;
  }
  return html + escapeHtml(line.slice(at));
}
